import type { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useLoggedIn } from "../helpers/loginHelpers";
import { routes } from "../app/routes";

/** this page will redirect to summary landing page if the user is logged in */
export const AnonRoute: FC<{ children: ReactNode }> = ({ children }) => {
  const isLoggedIn = useLoggedIn();

  if (isLoggedIn) {
    // Authenticated, go to summary landing page
    return <Navigate to={routes.summary.landingPage} replace />;
  }

  return <>{children}</>;
};
